import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  PageHeader,
  Card,
  Row,
  Col,
  Button,
  Spin,
  Tabs,
  Modal,
  notification,
  Result,
  Empty,
  Tooltip,
  message,
} from "antd";
import {
  LoadingOutlined,
  PlusOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  SyncOutlined,
  GiftOutlined,
  ScheduleOutlined,
  CheckCircleTwoTone
} from "@ant-design/icons";
import Swal from "sweetalert2";

import withReactContent from "sweetalert2-react-content";
import moment from "moment";
// import { fetchPlans } from '../api'; // Import your API function
import StripePlans from "./../components/StripePlans";
import PdProducts from "./../components/PdProducts";
import StripeGifts from "./../components/StripeGifts";
import CouponModal from "./../components/CouponModal";
import { subscriptionSync } from "./../components/SubscriptionSync";

import {
  getSubscriptions,
  unSubscription,
  createRetrunCheckout,
  giftSubscriptionCheckout,
  AppSupportedInfo,
  getBackGroundSync
} from "./../services";

const { Meta } = Card;
const { confirm } = Modal;

const MySwal = withReactContent(Swal);

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [spinner, setSpin] = useState(false);
  const [plans, setPlans] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [shipments, setShipmentData] = useState([]);

  
  const [giftsubscriptions, setGiftSubscriptions] = useState([]);
  const [planview, setPV] = useState(false);
  const [subCheck, setsubCheck] = useState({});
  const [drType, setdrType] = useState("subscription");
  const [extraData, setextraData] = useState({});
  const [AuthUser, setAuthData] = useState({});

  const [currentCoupon, setCouponCode] = useState(false);

  const query = useQuery();

  const handleSuccess = () => {
    MySwal.fire({
      title: "Payment successful!",
      text: "Your payment process is completed successfully.",
      icon: "success",
      confirmButtonText: "OK",
    });
  };

  const handleFailure = () => {
    MySwal.fire({
      title: "Payment Failed!",
      text: "Your payment process was unsuccessful.",
      icon: "error",
      // confirmButtonText: 'Try Again',
    });
  };

  const confirmHandler = (props, action) => {
    console.log(props);
    const { subscription } = props;
    const endDate = moment
      .unix(subscription.current_period_end)
      .format("MMMM DD, YYYY");

    console.log(endDate);
let thisMessage =``;

const amountTotal =  parseInt(props.amount_total);

if(amountTotal > 0  && props.sensor_shipment_period < 30){
  thisMessage =
  action === "canceled"
    ? `
    
    If you are unsatisfied with your Aletheia Products or the associated Services, you may cancel your Membership and return your Aletheia Sensor at your own expense within thirty (30) days of receiving the Sensor for a full refund of your Initial Membership Fee. The refund will be processed through your original payment method, less any return shipping costs. To initiate a return, contact Aletheia Run Support at <a href='mailto:support@aletheia.run'>support@aletheia.run</a>. A return shipping label will be provided to you. Once the return is requested, you will be eligible for a refund of your Initial Membership Fee, less any applicable return shipping costs, as long as the Aletheia Sensor (including hardware and any accessories) is received by Aletheia Run within thirty (30) days from the date the return was requested.
`
    : " ";
 } 


 if(amountTotal > 0  &&  props.sensor_shipment_period > 30){
  thisMessage =
  action === "canceled"
    ? `If more than thirty (30) days have passed, you may still return the Aletheia Sensor (including hardware and any accessories), but you will not be eligible for a refund of the Initial Membership Fee. While you can cancel your Membership at any time, cancellation after the 30-day period will take effect at the end of your initial subscription term. Once a return is initiated, Aletheia Run will deactivate the Account associated with the returned Sensor.`
    : " ";
 } 


    if(amountTotal === 0  && subscription.status==="trialing"){
     thisMessage =
     action === "canceled"
       ? `Members who cancel their Aletheia Run Trial during the Aletheia Run Trial period must return their Aletheia Sensor, Charger, and Belt within 7 days of cancellation (the “Return Period”). Members who return their Aletheia Sensor, Charger, and Belt during the Return Period will not be subject to any further fees or financial commitment to Aletheia Run. Return shipping is the responsibility of the Member. If a member cancels their Aletheia Run Trial but fails to return the Aletheia Sensor, Charger, and Belt within the Return Period, they may be charged a non-return equipment fee equal to the retail value of the Aletheia Sensor, Charger, and Belt.`
       : " ";
    } 


    if(amountTotal === 0 && subscription.status==="active"){
      thisMessage =
      action === "canceled"
        ? `If more than thirty (30) days have passed, you may still return the Aletheia Sensor (including hardware and any accessories), but you will not be eligible for a refund of the Initial Membership Fee. While you can cancel your Membership at any time, cancellation after the 30-day period will take effect at the end of your initial subscription term. Once a return is initiated, Aletheia Run will deactivate the Account associated with the returned Sensor.`
        : " ";
     } 

    // moment(endDate).format("MMMM DD, YYYY")

    function caps(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    Swal.fire({
      title: `Do you want to cancel your  membership?`,
      html: thisMessage,
      width:800,
      icon: action === "canceled" ? "warning" : "question",
      showCancelButton: true,
      confirmButtonColor:
        action === "canceled"
          ? "#d33"
          : action === "resume"
          ? "#4caf50"
          : "#3085d6",
      cancelButtonColor: "#ccc",
      confirmButtonText:
        action === "canceled"
          ? "Cancel subscription"
          : `${caps(action)} subscription`,
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        const thisObj = {};

        thisObj.id =
          action === "canceled"
            ? props.stripe_subscription_id
            : props.sub_schedule_id;
        thisObj.action = action;
        thisObj.endDate = endDate;
        thisObj.ref_id = props.id;

        handleUnsubscribe(thisObj);
      }
    });
  };

  const reloadPage = async () => {
    onloadData();
  };


  const messageLoader = (state) => {
    if(state===false){
      const hide = message.loading('Action in progress..', 0, () => {
        message.success('Loading Completed.');
      });
      return hide;
    } else {
      // Dismiss manually and asynchronously
      setTimeout(state, 2500);
    }
  };

  const onloadData = async () => {
    setLoading(true);
    const responData = await getSubscriptions();

    if (responData && responData.status !== "failure") {
      const { data } = responData;
      localStorage.setItem("subscriptions", JSON.stringify(data));
      
      const subsObj = {
        is_payment: data.is_payment,
        is_sensor: data.is_sensor,
        is_subscription: data.is_subscription,
        is_status: data.is_status,
        is_order_status: data.is_order_status,
        status: data.status,
        is_trail_period:data.is_trail_period
      };

      if (data.status) {

        setAuthData(localStorage.getItem("auth_data") ? JSON.parse(localStorage.getItem("auth_data"))  : false);

        setSubscriptions(data.data);
        setShipmentData(data.shippments);

        subsObj.customerId = data.data[0]["customer_id"];
      }
      setGiftSubscriptions(data.gift_subscriptions);
      setsubCheck(subsObj);
    }
    setLoading(false);
  };


  // const syncAPICall = async(syncUrl,interval) => {
  //    const key = "subscription-status";
  //    try {
  //         const res = await getBackGroundSync(syncUrl);
  //         const data = res;
  //         console.log("🔁 Sync check:", data);

  //         if (data.status === true) {
  //            onloadData();
  //           // ✅ Success: close loading and show success message
  //           notification.close(key);

  //           notification.success({
  //             message: "Subscription Created Successfully 🎉",
  //             description:
  //               "Your subscription has been successfully created. Thank you for your purchase!",
  //             icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
  //             placement: "topRight",
  //             // topRight, bottomRight, bottomLeft or topRight
  //             duration: 5,
  //           });
            
  //           localStorage.removeItem("sync_url");
  //           clearInterval(interval);
            
  //         }
  //       } catch (err) {
  //         console.error("❌ Sync check failed:", err);
  //       }
  // }
  // const  subscriptionSync = async(syncUrl) => {

  //    // 🚀 Open initial loading notification
  //     const key = "subscription-status";
  //     notification.open({
  //       key,
  //       message: "Subscription Creation in Progress",
  //       description: "Your subscription is being created. Please wait a moment...",
  //       icon: <Spin indicator={<LoadingOutlined style={{ color: "#1890ff" }} spin />} />,
  //       duration: 0, // stays open until manually closed
  //       placement: "topRight",
  //     });
      
  //     // ⏱️ Poll the sync URL every 30 seconds
  //     const interval = setInterval(async () => {
  //       syncAPICall(syncUrl);
  //     }, 4500); // 30 seconds
  //     syncAPICall(syncUrl,interval);

  //     // Cleanup on unmount
  //     return () => clearInterval(interval);
  // }

  useEffect(() => {

    
    const pmStatus = query.get("pm_status");
    const syncUrl = query.get("sync_url") || localStorage.getItem("sync_url");

    if (syncUrl) {
      localStorage.setItem("sync_url", syncUrl);
       subscriptionSync(syncUrl, () => {
         onloadData();
        console.log("✅ Subscription created — reloading dashboard data...");
        // Example: refetch your user subscriptions here
      });
      

    }
    if (pmStatus === "false") {
      handleFailure();
    }

    if (pmStatus === "true") {

      localStorage.removeItem("auth-token");
      localStorage.removeItem("checkout-data");

      handleSuccess();

    }


    const isShare =   localStorage.getItem("gift_share"); 
    if (isShare && isShare != "") {
      const couponData = {
        code :isShare,
        id :isShare,
      };
      shareCouponFunc(couponData);
    }

    const isCoupon = localStorage.getItem("coupon_code");
    

    if (isCoupon && isCoupon != "") {
      updateSubscribe("subscription", { coupon: true });
    }

      onloadData();


  }, []);
  



  const handleUnsubscribe = async (stripe_subscription_id) => {
    try {
      // Call your fetch API here
      const response = await unSubscription(stripe_subscription_id);

      console.log(response);

      const { message, status } = response;

      if (status === "success") {
        onloadData();
        if (stripe_subscription_id.action === "canceled") {
          // console.log(message,status);
          Swal.fire({
            title: "Subscription Canceled",
            html: `You may continue using Aletheia Run until the end of your subscription period.`,
            icon: "success",
          });

          // Show success notification
        } else {
          notification.success({
            message: message,
            description: "Your action has been completed successfully.",
          });
        }
      }
    } catch (error) {
      // Show error notification if API call fails
      notification.error({
        message: "Error",
        description: "Failed to unsubscribe the plan. Please try again later.",
      });
    }
  };

  const handleConfirmUnsubscribe = (props, action) => {
 
    console.log(props, action);

    confirmHandler(props, action);

    // confirm({
    //   title: `Do you want to  ${action} subscription  ?`,

    //   onOk() {
    //     handleUnsubscribe(thisObj);
    //   },
    // });
  };

  const updateSubscribe = (action, props) => {
    // console.log(action,props);
    setPV(true);
    setdrType(action);
    setextraData(props);
    localStorage.setItem("is_notification", false);
  };

  const createGiftSubscription = async () => {
    setPV(true);
    setdrType("gift_sub");
  };

  const proceedGiftSubscription  =async (giftPrice) =>{
      setSpin(true);


      message.loading('Action in progress..', 0);

      // // console.log(giftPrice);
      // subCheck.gift_id = giftPrice.id;
      // subCheck.unit_amount = giftPrice.unit_amount;
      
    const subResponse = await giftSubscriptionCheckout(giftPrice);
    
    if (subResponse && subResponse.status === "success") {
      const { url } = subResponse.data;

      window.location.href = url;
    } else {
      notification.error({
        message: "Warning",
        description: subResponse.message,
      });
    }

  

    setSpin(false);
  }

  const shareCouponFunc = (data) => {
    // console.log(data);

    setCouponCode(data);
  };

  const giftModalClose = () => {
    setCouponCode(false);
  };

  const createReturnLabel = async () => {
    setSpin(true);
     const [thisSubscripion] = subscriptions;
     const {shipstation_response} = thisSubscripion;
    const subResponse = await createRetrunCheckout({...subCheck,...shipstation_response});

    if (subResponse && subResponse.status === "success") {
      const { url } = subResponse.data;

      window.location.href = url;
    } else {
      notification.error({
        message: "Warning",
        description: subResponse.message,
      });
    }
    setSpin(false);
  };

  const isClose = () => {
    setPV(false);

    localStorage.setItem("is_notification", true);
  };

  console.log(subCheck);

  

  return (
    <div>

    <AppSupportedInfo isClosable={true} />

     
      {/* <Tabs defaultActiveKey="1">
    <Tabs.TabPane tab="Subscriptions" key="1">
      Content of Tab Pane 1
    </Tabs.TabPane>

  </Tabs> */}

      <PageHeader
        style={{ boxShadow: "0 0 1.5em #ccc", borderRadius: "20px" }}
        className="site-page-header"
        title={
          <>
            <CreditCardOutlined /> {subscriptions.length} {subscriptions.length > 1 ? 'Subscriptions' : 'Subscription'}  
          </>
        }
        // subTitle={`${subscriptions.length} Payment`}
        extra={[
          <>
            {/* {!loading &&
            subscriptions.length &&
            ["active", "paused"].indexOf(subCheck?.is_status) == -1 &&
            ["Received","pending_shipment", "In Transit", "Direct Purchase"].indexOf(
              subCheck?.is_order_status
            ) !== -1 ? (
              <Button
                icon={<PlusOutlined />}
                loading={spinner}
                type="primary"
                onClick={createReturnLabel}
              >
                Create Return Label
              </Button>
            ) : (
              " "
            )} */}

            {/* {!loading &&
            (AuthUser.user_type==='developer' || !subscriptions.length ||
              ["active", "paused"].indexOf(subCheck?.is_status) == -1) ? (
              <Button
                type="primary"
                onClick={() => updateSubscribe("subscription", {})}
              >
                <PlusOutlined /> Add Subscription
              </Button>
            ) : (
              " "
            )} */}

                {!loading &&
            <Button
                type="primary"
                onClick={() => updateSubscribe("subscription", {})}
              >
                <PlusOutlined /> Add Subscription
              </Button> }


      {/* <Button type="primary" onClick={createGiftSubscription}>
                <GiftOutlined style={{ fontSize: "25px" }} /> Gift Subscription
              </Button>  */}
          

            <Tooltip title="Refresh">
              <Button
                shape="circle"
                onClick={reloadPage}
                size={"large"}
                icon={<SyncOutlined />}
              />
            </Tooltip>
          </>,
        ]}
      />
     
      <Card style={{ marginTop: "15px" }}>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane
            tab={
              <>
                {" "}
                <ScheduleOutlined /> <b>Subscriptions</b>
              </>
            }
            key="1"
          >
            <div style={{ marginTop: "15px" }}>
              {loading ? (
                <Spin
                  size="large"
                  style={{ width: "100%", margin: " 0 auto" }}
                  indicator={
                    <LoadingOutlined
                      style={{
                        fontSize: 100,
                      }}
                      spin
                    />
                  }
                />
              ) : subscriptions && subscriptions.length ? (
                <Row className="pd_col_item" gutter={[16, 16]}>
                  {subscriptions.map((plan, index) => (
                    <Col key={index + 1} span={24}>
                      <StripePlans
                        {...plan}
                        index={index}
                        index_length={subscriptions.length}
                        unSubscribe={handleConfirmUnsubscribe}
                        updateSub={updateSubscribe}
                      />
                    </Col>
                  ))}

                
                </Row>
              ) : (
                <Result
                  
                  icon={<CalendarOutlined/> }
                  title="No Subscription Found."
                  subTitle=""
                  extra={
                    <Button type="primary" onClick={() => setPV(true)}>
                      <PlusOutlined /> Add Subscription
                    </Button>
                  }
                />
              )}
            </div>
          </Tabs.TabPane>

          {/* <Tabs.TabPane
              tab={
                <>
                  {" "}
                  <GiftOutlined />
                  <b>Gift Subscriptions</b>
                </>
              }
              key="2"
            >
              <div style={{ marginTop: "15px" }}>
                {loading ? (
                  <Spin
                    size="large"
                    style={{ width: "100%", margin: " 0 auto" }}
                    indicator={
                      <LoadingOutlined
                        style={{
                          fontSize: 100,
                        }}
                        spin
                      />
                    }
                  />
                ) : giftsubscriptions && giftsubscriptions.length ? (
                  <Row className="pd_col_item" gutter={[16, 16]}>
                    {giftsubscriptions.map((plan, index) => (
                      <Col key={index + 1} span={24}>
                        <StripeGifts
                          {...plan}
                          index={index}
                          index_length={giftsubscriptions.length}
                          unSubscribe={handleConfirmUnsubscribe}
                          updateSub={updateSubscribe}
                          shareCouponFunc={shareCouponFunc}
                        />
                      </Col>
                    ))}

                    {/* {subscriptions.length < 1 ? (
      <Col key={"1231546"} span={24}>
        <Result
          title="Add Subscription"
          icon={<CalendarOutlined />}
          subTitle=""
          extra={
            <Button type="primary" onClick={() => setPV(true)}>
              <PlusOutlined /> Add Subscription
            </Button>
          }
        />
      </Col>
    ) : (
      " "
    )}
                  </Row>
                ) : (
                  <Result
                  icon={<GiftOutlined/> }
                    title="No Gift Subscription Found."
                    subTitle=""
                    extra={
                      <Button type="primary" onClick={createGiftSubscription}>
                        <PlusOutlined /> Add Gift Subscription
                      </Button>
                    }
                  />
                )}
              </div>
            </Tabs.TabPane> */}
        </Tabs>
      </Card>
      <Spin spinning={spinner}>
      <PdProducts
        infoData={extraData}
        type={drType}
        isactive={planview}
        subsInfo={subCheck}
        shipments={shipments}
        isClose={isClose}
        giftCheckOut={proceedGiftSubscription}
     
      />
</Spin>
      {currentCoupon ? (
        <CouponModal onClose={giftModalClose} data={currentCoupon} />
      ) : (
        " "
      )}
    </div>
  );
};

export default Dashboard;
